<script setup lang="ts">
const props = defineProps<{
  item: Record<string, any>,
  shoppingSrc?: string,
}>();

const { oldFormatPrice } = useInputHelpers();

const modalsStore = useModalsStore();

const showMainModal = () => {
  modalsStore.openModal('CTA');
};
</script>

<template>
  <div v-if="props.item">
    <div class="flex">
      <div class="pack">
        {{ props.item.label }}
      </div>
    </div>
    <div class="text-sm text-center mb-2 mt-4">{{ props.item.title }}</div>
    <div class="flex flex-col items-center">
      <span
        class="flex items-center justify-center"
        :class="props.item.off && 'line-through decoration-[#FB977D] text-blue-400'"
      >
        <span :class="!props.item.off && 'text-xl font-extrabold'">
          {{ oldFormatPrice(props.item.price) }}
        </span>
        <span class="ms-1" :class="props.item.off && 'text-sm'">هزار تومان</span>
      </span>
      <div v-if="props.item.setupFee" class="text-sm">
        <div class="text-center">+</div>
        <div class="text-center mt-4">
          {{ oldFormatPrice(props.item.setupFee) }}<span class="ms-1">تومان</span>
        </div>
        <div class="text-center">هزینه راه‌اندازی</div>
      </div>
      <p class="relative flex-center mt-8 text-sm">قیمت هر پیامک</p>
      <div class="w-full flex items-center justify-center mb-8">
        <p class="text-base relative flex-center">
          از
          <span class="text-lg font-extrabold">133</span>
          تا
          <span class="text-lg font-extrabold">140</span>
          تومان
          <IconHighlight class="absolute top-5 w-20" />
          <Tooltip position="top">
              <template #activator>
                  <Icon 
                      name="solar:info-circle-linear" 
                      size="20" 
                      class="text-primary-600" 
                  />
              </template>
              <div
                  v-for="item, index in ['تعرفه پیامک به شماره‌های همراه اول = 133 تومان', 'تعرفه پیامک به شماره‌های سایر اپراتور‌ها = 140 تومان']"
                  :key="item"
                  class="w-50 lg:w-75 relative p-3! text-caption text-gray-500 text-start! z-1"
                  :class="index % 2 ? 'bg-gray-100' : 'bg-white'"
              >
                  {{ item }}
              </div>
          </Tooltip>
        </p>
      </div>
    </div>
    <div class="mt-4 mb-6">
      <BaseButton
        isLean
        size="full"
        text="ثبت سفارش"
        @click="showMainModal"
        class="rounded-lg h-[32px]"
        :id="setIdByPath('cta')"
      />
      <NuxtLink v-if="props.shoppingSrc" :to="props.shoppingSrc">
        <BaseButton
          size="full"
          text="خرید آنلاین"
          styleType="secondary"
          class="rounded-lg h-[32px] mt-2"
          :id="setIdByPath('onlineShopping')"
        />
      </NuxtLink>
    </div>
    <div v-if="props.item.options" class="flex flex-col my-4 gap-3">
      <div
        v-for="i in props.item.options"
        :key="'bo' + i.id"
        class="flex justify-start text-sm"
      >
        <div class="me-2">
          <IconLightTik v-if="i.isExists" class="stroke-blue-700 ml-2 h-6" />
          <IconCross v-else class="text-[#FB977D] w-4 h-4" />
        </div>
        <div class="text-gray-500">{{ i.title }}</div>
      </div>
    </div>
  </div>
</template>